<template>
  <div class="sidebar-container">
    <div class="aside-header">
      <!-- <div class="title-container"> -->
        <!-- <router-link :to="{ path: '/' }" class="logo-link"> -->
          <Logo :collapsed="menu_store.is_collapsed"></Logo>
        <!-- </router-link> -->
      <!-- </div> -->
    </div>
    <h-divider class="header-divider"></h-divider>
    <side-menu @change="$emit('change')"></side-menu>
    <a-button class="sidebar-toggle-btn" type="text" @click="handle_sidebar_toggle">
      <menu-collapse-toggle-button
        :collapsed="menu_store.is_collapsed"
      ></menu-collapse-toggle-button>
    </a-button>
  </div>
</template>
<script setup lang="ts">
import { useMenuStore } from '@/stores/menu'
import Logo from '@/components/core/company-logo.vue'
import sideMenu from '@/components/menu/menu.vue'
import HDivider from '@/components/core/h-divider.vue'
import menuCollapseToggleButton from '@/components/menu/menu-collapse-toggle-button.vue'

const menu_store = useMenuStore()

function handle_sidebar_toggle() {
  menu_store.toggleCollapsped()
}
</script>
<style scoped>
.sidebar-container {
  height: inherit;
}
.logo-link {
  color: var(--color-text);
}
.aside-header {
  height: 74px;
  background: var(--sidebar-header-background);
}
.title-container {
  display: inline-flex;
  padding: 12px 0 0 20px;
  cursor: pointer;
}
.menu-drawer {
  background: unset;
}

.sidebar-toggle-btn {
  margin: 15px 13px 0 15px;
  font-size: 1.3rem;
  padding: 0 15px;
  position: absolute;
  right: 0;
  bottom: 10px;
}
</style>
